module.exports = __webpack_public_path__ + "static/media/ishani.af44570f.jpg";